import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Route, RoutePlanElement, RoutePlanType } from 'src/app/models/route';
import { LanguageService } from 'src/app/services/account/language.service';
import { SettingsService } from 'src/app/services/account/settings.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { TurnValueIntegerThousandsPipe } from 'src/app/pipes/turn-value-integer-thousands.pipe';
import { InfoDialogComponent } from '../../../modals/info-dialog/info-dialog.component';
import { StackedModalsService } from 'src/app/services/modal/stacked-modals.service';
import { VehicleService } from 'src/app/services/vehicle/vehicle.service';
import { SvgRecolorDirective } from 'src/app/directives/svg-recolor.directive';

export interface RoutePlanClickEvent {
  routeEl: RoutePlanElement;
  index: number;
}

@Component({
  standalone: true,
  selector: 'app-route-plan',
  templateUrl: './route-plan.component.html',
  styleUrls: ['./route-plan.component.scss'],
  imports: [TurnValueIntegerThousandsPipe, SvgRecolorDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoutePlanComponent implements OnInit {
  @Input() routeData: Route | null = null;
  @Input() loadingMap: string = '';
  @Input() noRoute: boolean = false;
  @Input() activePlanningPanelRouteElement: number = -1;

  @Output() routePlanClick = new EventEmitter<RoutePlanClickEvent>();

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private cdr: ChangeDetectorRef,
    public settingsService: SettingsService,
    public utilsService: UtilsService,
    public languageService: LanguageService,
    private snackBar: MatSnackBar,
    private stackedModalsService: StackedModalsService,
    private vehicleService: VehicleService
  ) { }

  ngOnInit(): void {
  }

  public get RoutePlanType(): typeof RoutePlanType {
    return RoutePlanType;
  }

  public onRoutePlanClick(routeEl: RoutePlanElement, index: number): void {
    this.routePlanClick.emit({ routeEl, index });
  }

  public getChargeTime(chargeTimeHour: number, chargeTimeMin: number): string {
    return this.utilsService.getChargeTime(chargeTimeHour, chargeTimeMin);
  }

  public isFastchargeIcon(maxPercent: number): boolean {
    const fastChargeLimit = this.vehicleService.getFastChargeLimit();
    if (fastChargeLimit) {
      return fastChargeLimit < maxPercent && this.vehicleService.getSelectedCar().FastChargePower != 0;
    }
    return false;
  }

  public openBatteryReservedSnackbar(): void {
    this.snackBar.open(this.languageService.languageJSON.WarningSoc_popup, "", { duration: 5000, panelClass: 'snackbar-warning' });
  }

  public openFastchargeDialog(event: Event): void {
    event.stopPropagation();
    this.stackedModalsService.openModal(InfoDialogComponent,
      { data: { message: this.languageService.languageJSON.InfoSidebar_Info_FastChargeLimit }, autoFocus: false });
  }

  public getPlugLabel(icon: string | null): string {
    return this.utilsService.getPlugLabel(icon);
  }
}
